export class AddOrganisationConstants {
    static FORM_HEADER = "Add Organisation";
    static SAVE_BTN_TEXT_PLACEHOLDER = "Create";
    static ERROR_OBJECT_NAME = "Add Organisation";
    static UNIQUE_NAME = "Organisation with name ";
    static LOOKUP_ERROR_OBJECT_NAME = "Province-Lookup";
    static NUMBER_VALIDATOR_PATTERN = "^[+]?[0-9]*";
    static ORGANIZATION_LOGO_FORM_CONTROL = "Organisation logo";
}
